import { ILocationGratuity } from '@ready/dashboardv2api.contracts';
import { TipConfigurationService } from '../../../services/tipConfigurationService';
import { TIP_CONFIGURATION_ACTION_TYPES } from './tipConfigurationActionTypes';

export interface TipConfigurationAction {
  type: string;
  payload?: any;
}

// Fetch tip configuration actions
export const fetchTipConfigurationBegin = (): TipConfigurationAction => ({
  type: TIP_CONFIGURATION_ACTION_TYPES.FETCH_TIP_CONFIGURATION_BEGIN,
});

export const fetchTipConfigurationSuccess = (data: ILocationGratuity): TipConfigurationAction => ({
  type: TIP_CONFIGURATION_ACTION_TYPES.FETCH_TIP_CONFIGURATION_SUCCESS,
  payload: data,
});

export const fetchTipConfigurationError = (): TipConfigurationAction => ({
  type: TIP_CONFIGURATION_ACTION_TYPES.FETCH_TIP_CONFIGURATION_ERROR,
});

// Update tip configuration actions
export const updateTipConfigurationBegin = (): TipConfigurationAction => ({
  type: TIP_CONFIGURATION_ACTION_TYPES.UPDATE_TIP_CONFIGURATION_BEGIN,
});

export const updateTipConfigurationSuccess = (data: ILocationGratuity): TipConfigurationAction => ({
  type: TIP_CONFIGURATION_ACTION_TYPES.UPDATE_TIP_CONFIGURATION_SUCCESS,
  payload: data,
});

export const updateTipConfigurationError = (): TipConfigurationAction => ({
  type: TIP_CONFIGURATION_ACTION_TYPES.UPDATE_TIP_CONFIGURATION_ERROR,
});

// Async action creators
export const fetchTipConfiguration = (companyId: string, locationId: string) => {
  return async (dispatch: any) => {
    try {
      dispatch(fetchTipConfigurationBegin());
      const data = await TipConfigurationService.getTipConfiguration(companyId, locationId);
      dispatch(fetchTipConfigurationSuccess(data));
      return data;
    } catch (error) {
      dispatch(fetchTipConfigurationError());
      throw error;
    }
  };
};

export const updateTipConfiguration = (companyId: string, locationId: string, config: ILocationGratuity) => {
  return async (dispatch: any) => {
    try {
      dispatch(updateTipConfigurationBegin());
      const data = await TipConfigurationService.updateTipConfiguration(companyId, locationId, config);
      dispatch(updateTipConfigurationSuccess(data));
      return data;
    } catch (error) {
      dispatch(updateTipConfigurationError());
      throw error;
    }
  };
};